import { useGeo, useStores } from "@sushicorp/contexts";
import { useShippingAddress } from "@sushicorp/contexts";
import { useFetchDefaultStore } from "@sushicorp/services";
import { useFetchNearbyStores } from "@sushicorp/services";
import { events } from "artisn/analytics";
import { useEffect } from "react";

import useAnalytics from "contexts/analytics/analytics.context.hooks";
import { notify } from "utils/common.utils";

const { logSetStore, logChangeStore } = events.store;

const useListenStores = () => {
  const { setDefaultStore, setSelectedStore, setNoCoverage } = useStores();
  const { selectedShippingAddress } = useShippingAddress();
  const { analyticsInitialized } = useAnalytics();
  const { selectedCoordinates } = useGeo();
  const { data: defaultStore } = useFetchDefaultStore(notify);
  const fetchNearByStores = useFetchNearbyStores(selectedCoordinates, notify);
  const { data: nearbyStores, isLoading } = fetchNearByStores;

  /* Set default store on context if default store changes. */
  useEffect(() => {
    if (!defaultStore) return;
    setDefaultStore(defaultStore);
  }, [defaultStore, setDefaultStore]);

  /** Set selected store if there is a nearby store or a default store. */
  useEffect(() => {
    const selectedStore = nearbyStores?.[0] ?? defaultStore;

    setSelectedStore(previousStore => {
      // Send analytics events
      if (!previousStore && selectedStore && analyticsInitialized) {
        logSetStore({ store: selectedStore });
      } else if (previousStore && selectedStore && analyticsInitialized) {
        logChangeStore({
          previousStore,
          nextStore: selectedStore
        });
      }
      return selectedStore;
    });
  }, [nearbyStores, defaultStore, setSelectedStore, analyticsInitialized]);

  /**
   * Set coverage if there aren't nearby stores and selected shipping address.
   */
  useEffect(() => {
    const noClosestStore = !nearbyStores?.length && !isLoading;
    setNoCoverage(noClosestStore && !!selectedShippingAddress);
  }, [nearbyStores?.length, isLoading, selectedShippingAddress, setNoCoverage]);
};

export default useListenStores;
